<nav [class.absolute-header]="shouldUseAbsolutePosition" class="header">
  <div class="header-content">
    <div class="top-menu-container">
      <div class="top-menu-right-container">
        <a [routerLink]="'/'" class="focus-link">
          <img [alt]="logoAltText" [src]="logoImageUrl" class="anz-logo" />
        </a>
        <span aria-hidden="true" class="anz-header-portal-name">
          {{ 'wl.anz.header.title' | translate }}
        </span>

        <ul class="top-menu-items-container">
          <li class="top-menu-item-container">
            <button
              [dataTestid]="'anz-header-menu-button-redeem'"
              id="redeem"
              (click)="onMenuItemClick('redeem')"
              [attr.aria-expanded]="getExpandedStatus('redeem')"
              [class.top-menu-item-active]="getExpandedStatus('redeem')"
              aria-haspopup="listbox"
              class="top-menu-item redeem-group focus-link">
              {{ 'wl.anz.header.redeem' | translate }}
            </button>
            <div [attr.aria-hidden]="!getExpandedStatus('redeem')">
              <ul
                [class.shown]="getExpandedStatus('redeem')"
                class="child-menu-items-container hidden">
                <li
                  (click)="onChildMenuItemClick(navLink)"
                  *ngFor="let navLink of navlinksService.redeem; let i = index"
                  class="child-menu-item">
                  <a
                    role="menuitem"
                    #redeemLink
                    [class.child-menu-item-link-active]="
                      isActivatedChildMenuItem(navLink.route)
                    "
                    [routerLink]="[navLink.route]"
                    [dataTestid]="navLink.dataTestid"
                    class="child-menu-item-link redeem-group focus-link"
                    id="redeem-{{ i }}"
                    tabindex="-1">
                    {{ navLink.translationKey | translate }}
                  </a>
                </li>
              </ul>
            </div>
          </li>
          <li *ngIf="isLoggedIn$ | async" class="top-menu-item-container">
            <button
              [dataTestid]="'anz-header-menu-button-my-account'"
              id="account"
              (click)="onMenuItemClick('myAccount')"
              [attr.aria-expanded]="getExpandedStatus('myAccount')"
              [class.top-menu-item-active]="getExpandedStatus('myAccount')"
              aria-haspopup="listbox"
              class="top-menu-item account-group focus-link">
              {{ 'wl.anz.header.rewards' | translate }}
            </button>
            <div [attr.aria-hidden]="!getExpandedStatus('myAccount')">
              <ul
                [class.shown]="getExpandedStatus('myAccount')"
                class="child-menu-items-container hidden">
                <li
                  (click)="onChildMenuItemClick(navLink)"
                  *ngFor="let navLink of navlinksService.rewards; let i = index"
                  class="child-menu-item">
                  <a
                    role="menuitem"
                    #accountLink
                    *ngIf="!isExternalNavLink(navLink.route)"
                    [class.child-menu-item-link-active]="
                      isActivatedChildMenuItem(navLink.route)
                    "
                    [routerLink]="[navLink.route]"
                    [dataTestid]="navLink.dataTestid"
                    class="child-menu-item-link account-group focus-link"
                    id="account-{{ i }}"
                    tabindex="-1">
                    {{ navLink.translationKey | translate }}
                  </a>

                  <a
                    role="menuitem"
                    #accountLink
                    *ngIf="isExternalNavLink(navLink.route)"
                    [class.child-menu-item-link-active]="
                      isActivatedChildMenuItem(navLink.route)
                    "
                    [href]="[navLink.route]"
                    [dataTestid]="navLink.dataTestid"
                    class="child-menu-item-link account-group focus-link"
                    id="account-{{ i }}"
                    tabindex="-1">
                    {{ navLink.translationKey | translate }}
                  </a>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
      <div class="header-buttons-container flex items-center">
        <rd-sc-header-icon
          [dataTestid]="'anz-header-button-cart'"
          *ngIf="
            featureFlagService.isEnable(shoppingCartFeatureFlag) &&
            (isLoggedIn$ | async)
          "
          [itemCount]="
            cartItemFacade.cartItemsTotalLineItems$ | async
          "></rd-sc-header-icon>

        <ng-container *ngIf="!isAnzSSOEnabled">
          <rd-shared-button
            [dataTestid]="'anz-header-button-activate'"
            (clickFn)="handleUserAction('enroll')"
            *ngIf="!(isLoggedIn$ | async)"
            [ariaLabel]="'wl.anz.accessibility.header.activate' | translate"
            [buttonContent]="activateButtonContent"
            buttonTheme="outline-primary"
            class="header-button">
            <ng-template #activateButtonContent>
              <span>{{ 'wl.anz.header.activate' | translate }}</span>
            </ng-template>
          </rd-shared-button>
        </ng-container>

        <rd-shared-button
          [dataTestid]="'anz-header-button-login'"
          (clickFn)="handleUserAction('login')"
          *ngIf="!(isLoggedIn$ | async)"
          [buttonContent]="loginButtonContent"
          [iconPath]="getButtonIconPath()"
          buttonTheme="primary"
          class="header-button anz-login-button bypass-block-target">
          <ng-template #loginButtonContent>
            <span>{{ 'wl.anz.header.login' | translate }}</span>
          </ng-template>
        </rd-shared-button>

        <rd-shared-button
          [dataTestid]="'anz-header-button-logout'"
          (clickFn)="handleUserAction('logout')"
          *ngIf="isLoggedIn$ | async"
          [buttonContent]="logoutButtonContent"
          [iconPath]="getButtonIconPath()"
          buttonTheme="outline-primary"
          class="header-button anz-logout-button bypass-block-target my-auto">
          <ng-template #logoutButtonContent>
            <span>{{ 'wl.anz.header.logout' | translate }}</span>
          </ng-template>
        </rd-shared-button>
      </div>
      <ng-container *ngTemplateOutlet="desktopCardSelector"></ng-container>
    </div>
  </div>
</nav>

<rd-anz-mobile-header
  class="visible lg:invisible"
  [cardSelectorDisabled]="cardSelectorDisabled"></rd-anz-mobile-header>

<!--Adding card selector template here for re-use-->
<ng-template #desktopCardSelector>
  <div class="child-menu-container points-summary-container">
    <div *ngIf="isLoggedIn$ | async" class="points-summary relative">
      <ng-container
        *ngIf="pointsSummaryFacade.pointsSummary$ | async as pointsSummary">
        <ng-container
          *ngIf="activePointsAccount$ | async as activePointsAccount">
          {{ activePointsAccount?.enrollments[0]?.groupName + ':' }}
          <strong *ngIf="loyaltyCurrency$ | async as loyaltyCurrency">
            &nbsp;
            {{ pointsSummary.pointsBalance | localizePointsNumber: '1.0-0' }}
            {{ loyaltyCurrency.name }}
          </strong>

          <ng-container *ngIf="expiryPoints$ | async as expiryPoints">
            <ng-container
              *ngIf="
                'wl.anz.header.tooltips'
                  | translate
                    : {
                        expiryPoints: expiryPoints,
                        loyaltyCurrency: (loyaltyCurrency$ | async).name,
                        expiryDate: lastDayInYear
                      } as tooltipsContent
              ">
              <button
                #expiryPointsButton
                class="focus-link ml-2 h-4 max-h-full w-4 max-w-full border-none bg-transparent p-0 hover:cursor-pointer"
                (click)="showExpiryPointsTooltip()"
                [attr.aria-label]="tooltipsContent">
                <rd-shared-icon
                  iconSymbol="icon-warning-solid"></rd-shared-icon>
              </button>

              <rd-anz-tooltips
                #expiryPointsTooltips
                [attr.aria-label]="
                  'wl.anz.header.accessibility.expiry_points_tooltips'
                    | translate
                "
                (visibilityChanged)="onTooltipsVisibilityChanged()">
                <span class="mr-2"> {{ tooltipsContent }} </span>
              </rd-anz-tooltips>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>

    <div
      *ngIf="(pointsAccountFacade.pointsAccounts$ | async)?.length > 1"
      [class.open]="open"
      class="card-selector-container">
      <button
        #button
        (click)="handCardSelectorClick()"
        (rdClickOutside)="closeCardSelector()"
        [attr.aria-expanded]="open"
        [attr.aria-label]="'wl.anz.header.cards_selector' | translate"
        [disabled]="cardSelectorDisabled"
        aria-haspopup="listbox"
        class="card-selector-button focus-link"
        type="button">
        <rd-shared-icon
          [iconSymbol]="'icon-chevron-down'"
          class="expander-arrow"></rd-shared-icon>
      </button>
      <ul class="card-enrollment-container">
        <li
          *ngFor="
            let pointsAccount of pointsAccountFacade.pointsAccounts$ | async
          ">
          <ng-container *ngIf="loyaltyCurrency$ | async as loyaltyCurrency">
            <rd-anz-card-selector
              (clickEvent)="handleClick($event)"
              [active]="
                isPointsAccountActive(
                  pointsAccount,
                  this.pointsAccountId$ | async
                )
              "
              [loyaltyCurrency]="loyaltyCurrency"
              [pointsAccount]="pointsAccount"></rd-anz-card-selector>
          </ng-container>
        </li>
      </ul>
    </div>
  </div>
</ng-template>
